import type { UUID } from '@/types/Id'
import type { Document } from '@/types/pursuit/Document'

/**
 * Which document a stored .docx opens.
 *
 * A file opens as one document — its working copy, pointed back at the file
 * (`file_id`). Archived copies are skipped: archiving one is what frees a file for
 * a fresh copy, so the file reads as unopened once its copy is put away.
 */
const workingCopyFileId = (document: Document): UUID | null =>
  document.archived ? null : (document.file_id ?? null)

/** The rule over a whole list, for surfaces resolving many files at once. */
export const buildDocumentsByFile = (
  documents: Document[] | undefined,
): Map<UUID, Document> => {
  const byFile = new Map<UUID, Document>()
  for (const document of documents ?? []) {
    const fileId = workingCopyFileId(document)
    if (fileId && !byFile.has(fileId)) {
      byFile.set(fileId, document)
    }
  }
  return byFile
}
